<app-user-header class="d-md-none"></app-user-header> 


<div class="wrapperi">
  <div class="ps-4 pt-4 pb-0 pe-4">
    <div class="col-12">

      <div class="pointer" (click)="goBack()">
          <p class="semiboldlinkblue16 mb-0"><img class="chevron-margins" src="../../assets/icons/chevron_left.svg"/>Takaisin</p>
      </div>
      <div class="mt-3" *ngIf="!openingID">
        <p class="semiboldtextblue24">Lisää työpaikka</p>
      </div>
      
  </div>
  </div>


      <div class="col-12 d-flex justify-content-center" *ngIf="showLogoErr">
        <div class="alert alert-danger">
          <p class="">Yritykselläsi ei ole logoa lisättynä! Mikäli logoa ei lisätä näytetään sen tilalla Formedin logo</p>
        </div>
      </div>

      <div class="ps-4 pe-4 pt-2">
        <div class="formed-shadow mb-4">
          <div class="p-4">
            <div class="col-12 p-0 row m-0">
              <div class="col-12 p-0 input-cover">
                <div class="col-12 p-0">
                  <div class="alert alert-warning" *ngIf="messageErr">
                    <p class="text-center">Samalla nimellä löytyi jo</p>
                  </div>
                </div>
        
        <!--         <input type="text" id="firstName">
                <input  type="text" id="lastName">
                <button (click)="sendjt()">Lisää</button> -->
          
                <div id="loader" class="loader-container mt-4" *ngIf="isLoading" >
                  <div class="loader mx-auto"></div>
                  <p class="text-center pt-3">Odota...</p>
                </div>
          
                <div style="display: block;" id="form-container" [ngStyle]="{ 'display': isLoading ? 'none' : 'block' }" class="">
                  <form class="flex-row add-asd-form" [formGroup]="form"
                  (ngSubmit)="onSubmit()">
                    <div [ngClass]="currentScreen == 1 ? '' : 'd-none'">
                    

                      <div class="col-12">
                        <p class="semiboldtextblue90020 mb-2">Ilmoituksen otsikko</p>
                        <div class="form-floating mb-2  col-12 col-md-8 ps-0">
                          <input type="text" (keyup)="countChars()" minlength="3" maxlength="100" placeholder="kirjoita tähän ilmoituksen otsikko" formControlName="title" id="title" class="form-control" >
                          <label class="">Ilmoituksen otsikko</label>
          
                      </div>
                      </div>
        
                    <div class="" *ngIf="!openingID">
                      
                      <!-- Etunimi ja sukunimi -->
                      <p class="semiboldtextblue80016 mb-0">Valitse toimipiste tai syötä sijainti manuaalisesti</p>
                      <p class="normaltextgray14">Voit lisätä toimipisteitä Asetukset -sivulla</p>

                      <div class="col-12 col-md-4 row m-0 pt-2">
        
                          <div class="form-floating mb-2 col-12  p-0">
                              <select (change)="subGroupSelected($event)" type="text" id="group-type" placeholder="Valitse alaryhmä" class="form-control form-select" >
                                  <option value="">- Valitse -</option>
                                  <option *ngFor="let data of subGroups" value="{{data._id}}">{{data.businessName}}</option>
                                  </select>
                              <label for="group-type">Toimipiste</label>
                          </div>
              
                      </div>
                      <!-- Työsyhteen kesto -->
            
                      <div class="d-flex ps-2 mt-3" >
                        <div class=" justify-content-end">
                          <input type="checkbox" (change)="displayLocationDetails()" id="no_use_subgroup" >
                        </div>
                        <div class="col justify-content-start ms-3">
                          <p>Haluan lisätä sijainnin manuaalisesti</p>
                        </div>
                      </div>
                      <div id="location-details" style="display: none;" class="">
                        <p class="semiboldtextblue80016 mb-0">Syötä osoitetiedot</p>
                        <p class="normaltextgray14">Täytä tarkat sijaintitiedot tai valitse seuraavasta kohdasta alueellinen sijainti. Voit myös lisätä pelkän kaupungin. Tässä tapauksessa jätä muut kentät tyhjäksi.</p>

                        <div class="col-12 row m-0 pt-2" >
            
                          <div class="form-floating mb-2 col-12 col-md-4 ps-0">
                              <input type="text" placeholder="Paikkakunta" formControlName="city" id="city" class="form-control" >
                              <label for="city">Paikkakunta</label>
              
                          </div>
                          <div class="form-floating mb-2 col-12 col-md-4 p-0">
                            <input type="text" placeholder="Osoite" formControlName="address" id="address" class="form-control" >
                            <label for="address">Osoite</label>
            
                        </div>
                        <div class="col-md-2">
                          <div class="form-floating mb-2 ps-0">
                            <input type="text" placeholder="Postinumero" formControlName="zip" id="zip" class="form-control" >
                            <label for="zip">Postinumero</label>
            
                        </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-8 row m-0 p-0 pt-2">
                        <p class="semiboldtextblue80016 mb-0 ps-0">Alueellinen sijainti</p>
                        <p class="normaltextgray14 ps-0">Jos et syöttänyt tarkkoja sijaintitietoja, valitse alueellinen sijainti</p>

                        <div class="form-floating mb-2 col-8  p-0">
                            <select type="text" id="not_spesific_location" placeholder="Alueellinen sijainti" class="form-control form-select" >
                                <option value="">- Valitse -</option>
                                <option *ngFor="let data of wellfareAreas" value="{{data.id}}">{{data.name_fi}}</option>
                                </select>
                            <label for="group-type">Alueellinen sijainti</label>
                        </div>
            
                    </div>
                      </div>
                    </div>
                    
                    <div class="" *ngIf="openingID">
                      <p class="semiboldtextblue24">Muokkaa työpaikkaa</p>
                    </div>
                    
                    
                  <!-- Etunimi ja sukunimi -->
                  <p class="semiboldtextblue80016 mt-4 mb-0">Haettava positio</p>
                  <p class="normaltextgray14 mb-0">Syötä hakukenttään haettava ammattinimike ja klikkaa sitä.</p>

                  <div class="col-12 row m-0 pt-2">
                    
                    <div class="col-12 col-md-4 ps-0">
                      <div class="form-floating mb-2 p-0">
                        <input type="text" id="md-type-search" autocomplete="off" (keyup)="onSearchMdType()" placeholder="Hae..."  class="form-control" >
                        <label for="md-type">Hae...</label>
                        
                    </div>
                      <div class="floating-search" *ngIf="show_mdtypes && show_mdtypes.length > 0">
                       
                        <div class="floating-search-results" >
                          <p class="semiboldtextblue16">Valitse Listasta</p>
                          <div class="floating-search-result" *ngFor="let data of show_mdtypes" (click)="mdtypeSelectedNew(data)">
                            <p class="mb-0 normaltextblue80016">{{data.name_fi}}</p>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="col-4">
                      <div class="form-floating mb-2 p-0" *ngIf="selectedSubtypes && selectedSubtypes.length > 0">
                        <select type="text" (keyup)="selectSubtype()" id="md-sub-type" placeholder="Poisitio" class="form-control" >
                          <option value=""></option>
                          <option *ngFor="let data of selectedSubtypes" value="{{data.id}}">{{data.name_fi}}</option>
                          </select>
                        <label for="md-sub-type">Erikoisala*</label>
                    </div>
                    </div>
        
          
                  </div>
                  <ng-container *ngIf="work_possibilities">
                    <div class="col-12 row ms-0 me-0 mt-3">
                      <div class="col-12 col-md-4 ps-0">

                        <div class="form-floating mb-2 p-0">
                          <select type="text" id="work_type_select" placeholder="Työsuhde" class="form-control form-select" >
                            <option value="">- Valitse -</option>
                            <option *ngFor="let data of work_possibilities" value="{{data.id}}">{{data.name_fi}}</option>
                            </select>
                          <label for="work_type_select">Työsuhde*</label>
                      </div>
                        
                      </div>
                      <div class="col-12 col-md-4 ps-0 ps-md-2">
                        <div class="form-floating mb-2 p-0">
                          <select type="text" id="timing" placeholder="Työaika" class="form-control form-select" >
                            <option value="">- Valitse -</option>
                            <option *ngFor="let data of timing" value="{{data.id}}">{{data.name_fi}}</option>
                            </select>
                          <label for="timing">Työaika*</label>
                      </div>
                      </div>
                    </div>

                  </ng-container>
        
                
                    <!-- Työsyhteen kesto ei pakollinen-->
                    <p class="semiboldtextblue80016 mt-2 mb-0">Palkkaus</p>
                    <p class="normaltextgray14">Syötä palkkatiedot kuukausi- tai tuntipalkkana. Palkan ilmoittaminen parantaa työpaikkailmoituksen näkyvyyttä.</p>
        
                    <div class="d-flex m-0">

                        <div class="form-floating mb-2  wid-150 ps-0" *ngIf="type != 'quickapplication'">
                            <input type="number" onmousewheel="return false;" min="0" placeholder="Kuukausipalkka €/kk" formControlName="wage_min" id="wage_min" class="form-control" >
                            <label class="" for="wage_min">Min</label>
            
                        </div>
                        <div class="justify-content-center">
                          <hr class="wagehr">
                        </div>
        
                        <div class="form-floating mb-2 wid-150 ps-0">
                            <input type="number" onmousewheel="return false;" min="0" placeholder="Tuntipalkka €/h" formControlName="wage_max" id="wage_max" class="form-control" >
                            <label for="wage_max">Max</label>
            
                        </div>
                        <div class="ms-4">
                          <div class="flex-column">
                            <div class="d-flex">
                              <div class="f-checkbox">
                                <input class="wage-type" (click)="checkOnlyOneChoise('wage-type', 'monthlywage')" type="checkbox" id="monthlywage">
                                <label for="monthlywage"></label>
                            </div>
                            <p class="mb-1 ms-2">Kuukausipalkka</p>
                            </div>
                      
                          </div>
                          <div class="flex-column">
                            <div class="d-flex">
                              <div class="f-checkbox">
                                <input class="wage-type" (click)="checkOnlyOneChoise('wage-type', 'hourlywage')" type="checkbox" id="hourlywage">
                                <label for="hourlywage"></label>
                            </div>
                            <p class="mb-1 ms-2">Tuntipalkka</p>
                            </div>
                      
                          </div>
                        </div>
            
        
                    </div>



                    <p class="semiboldtextblue80016 mt-2 mb-0">Etätyö</p>
                    <p class="normaltextgray14">Valitse vetovalikosta etätyömahdollisuus</p>

                    <div class="col-12 col-md-4 row m-0 pt-0">
      
                        <div class="form-floating mb-2 col-12  p-0">
                            <select type="text" formControlName="remote_possibility" placeholder="Etätyö" class="form-control form-select" >
                                <option value="">- Valitse -</option>
                                <option *ngFor="let data of tele_types" value="{{data.id}}">{{data.name_fi}}</option>
                                </select>
                            <label for="group-type">Etätyö*</label>
                        </div>
            
                    </div>
        
                      <p class="semiboldtextblue80016 mt-2 mb-0">Hakuajan päättyminen</p>
                      <p class="normaltextgray14">Syötä päivämäärä tai klikkaa kalenterikuvaketta valitaksesi päättymispäivän</p>

                      <div class="mt-2">
        
                        <div class="form-floating mb-2 col-12 col-md-4 p-0">
                            <input type="date" placeholder="Päättymispäivä" formControlName="application_ends" id="application_ends" class="form-control" >
                            <label class="" for="application_ends">Päättymispäivä</label>
            
                        </div>
                      </div>
<!--                       <p class="semiboldtextblue80016 mt-4 mb-1">YouTube-linkki</p>
                      <p class="normaltextgray14">Paranna työpaikan kiinnostavuutta lisäämällä YouTube-video, joka esittelee työnantajan tai tarjolla olevan työpaikan.</p>

                      <div class="mt-2">
        
                        <div class="form-floating mb-2 col-12 col-md-4 p-0">
                            <input type="url" placeholder="youtube-linkki" formControlName="youtubeLink" id="youtubeLink" class="form-control" >
                            <label class="" for="youtubeLink">Linkki</label>
            
                        </div>
                      </div> -->
                      
<!--                   <div class="col-12">
                        <p class="semiboldtextblue80016 mb-0">Avainsanat (PRO)</p>
                        <p class="normaltextgray14">Lisää ilmoitukseesi työpaikkaa kuvaavia avainsanoja. Avainsanojen käyttö parantaa ilmoituksen näkyvyyttä ja kohdennusta. Avainsanoja voivat olla esimerkiksi: <i>osastonlääkäri, vastaanottotyö, seniorituki, perehdytys, diabeteshoitaja, hampaan poisto, Varsinais-Suomi, Naantali, Lieto </i></p>
                        <div class="form-floating mb-2  col-12 col-md-8 ps-0">
                          <input type="text" (keyup)="countChars()" minlength="3" maxlength="70" placeholder="Ilmoituksen hakusanat" formControlName="keywords" id="keywords" class="form-control" >
                          <label class="" for="keywords">Ilmoituksen hakusanat</label>
          
                      </div>
                      <div class="col-md-8">
                        <p class="normaltextgray14">Max 70 merkkiä ({{charLen}}/70)</p>

                      </div>
                      </div>  -->
                <!-- Etunimi ja sukunimi -->
                <p class="semiboldtextblue80016 mt-2 mb-1">Kuvaus</p>
                <p class="normaltextgray14">Kerro työnhakijoille tarkemmin, mistä työpaikassa on kyse ja mitä olette etsimässä. Pidä kuvaus lyhyenä ja ytimekkäänä. Tuo selkeästi edut ja hyödyt esille!</p>

                  <div class="col-12 col-md-8 row m-0 pt-2">
          
                    <div class="mb-2 col-12 p-0">
                        <textarea type="text" style="height:250px" placeholder="Työpaikkailmoituksen kuvaus" formControlName="description" id="deription" class="form-control" ></textarea>
        
                    </div>
                    </div>
                  </div>
                  <p class="semiboldtextblue80016 mt-2 mb-1">Hakemusten käsittely</p>
                  <p class="normaltextgray14 mb-1">Valitse haluatko vastaanottaa hakemukset Rekruu järjestelmään vai ohjata hakijat omalle sivustollesi. Rekruussa hakijat voivat hakea omalla profiilillaan paikkaa.</p>

                  <div class="">
                    <div class="flex-column">
                      <div class="d-flex">
                        <div class="f-checkbox">
                          <input type="checkbox" id="fCheckRekruuApplication" class="application-check" (click)="checkOnlyOneChoise('application-check', 'fCheckRekruuApplication')" checked>
                          <label for="fCheckRekruuApplication"></label>
                      </div>
                      <p class="mb-1 ms-2">Rekruu</p>
                      </div>
                
                    </div>
                    <div class="flex-column mt-2">
                      <div class="d-flex">
                        <div class="f-checkbox">
                          <input type="checkbox" class="application-check" (click)="checkOnlyOneChoise('application-check', 'fCheckURL')" id="fCheckURL">
                          <label for="fCheckURL"></label>
                      </div>
                      <p class="mb-1 ms-2">Linkki omalle sivustolle</p>
                      </div>
                
                    </div>
                  </div>
  
                    <div class="col-12 col-md-8 row m-0 pt-2">
            
                          <input type="text"  placeholder="Lisää URL-osoite hakulomakkeelle" formControlName="application_url" class="form-control" />
          
                      
                      </div>
                  <p class="semiboldtextblue80016 mt-2 mb-1">Ilmoitukset</p>
                  <p class="normaltextgray14 mb-1">Haluatko sinä tai joku teidän organisaatiostanne saada ilmoituksia sähköpostitse uusista kiinnostuneista. Valitse käyttäjät listasta</p>
                  <p (click)="openRecievers()" class="semiboldlinkblue16 pointer">Valitse ilmoituksen saajat</p>

                  <div class="row">
                  <div class="col-6" *ngFor="let data of saved_users">
                    <div class="formed-list bg-f-b">
                        <div class="p-2">
                            <div class="col-12 row m-0 p-0">
                                <div class="col-12 col-md-4 p-0">
                                    <div class="d-inline-flex">
                                        <div class="pe-2" *ngIf="!data.profilePicture; else pic_added">
                                            <img class="rounded-circle" [ngClass]="data.mainUser ? 'golden-radius' : ''" src="../../assets/icons/formed_no_profile.svg" height="50" alt="">
                                        </div>
                                        <ng-template #pic_added>
                                            <div class="pe-2">
                                                <img class="rounded-circle" [ngClass]="data.mainUser ? 'golden-radius' : ''" src="{{data.profilePicture}}" height="50" alt="">

                                            </div>
                                        </ng-template>
                                        <div class="d-flex flex-column align-self-center">
                                            <p class="formed-sub-title mb-0">{{data.firstName}} {{data.lastName}}
                                                <span title="Aktivointikoodia ei aktivoitu määräajassa" *ngIf="data.isExpired">
                                                    <img height="20" width="20" src="../../assets/icons/alert.svg" alt="">
                                                </span>
                                            </p>
                                            <p class="normaltextblue80016 mb-0">{{data.email}}</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="d-flex justify-content-start">
                      <div class="col-3">
                        <div class="" *ngIf="openingID">
                          <button [disabled]="form.invalid" class="btn mt-4  btn-formed-main-blue w-100">{{btnText}}</button>

                        </div>


                      </div>

                    </div>
                  </div>
                    
                    <div class="">
                    <div class="" *ngIf="!openingID">
                    <div class="col-12 row">
        
<!--                   <div class="col-12 p-0 row">
                    <div class="col-8 ps-0">
                      <div class="bg-w">
                        <div class="p-4">
                          <h1 class="semiboldtextgreen20">Valitse näkyvyyden taso</h1>
                          <p class="mt-2 normaltextblue14">Perusilmoitus on aina ilmainen. Boostedin avulla erotut muiden työpaikkailmoitusten joukosta ja nostamme ilmoituksesi sovelluksen etusivulle.</p>
                          <div class="col-12 row ps-0 pe-0 pt-30">
                            <div class="col-6">
                                <div class=" formed-shadow formed-price-bg h-100">
                                    
                                    <div class="p-4">
                                      <p class="normaltextgray20 mb-3">Perusilmoitus <span *ngIf="days_ad_amount == 0">(Valittu)</span></p>
                                      <div class="d-flex">
                                        <div class="">
                                          <h2 class="formed-gray-price mb-0">0€</h2>
                                        </div>
                                        <div class="mt-3 ms-2">
                                          <p class="gray text-center mb-0">/pv</p>
                                        </div>
                                      </div>
                                      <div class="ps-3 pe-3 pt-2">
                                        <hr class="hr-gray">
                                      </div>
                                      <div class="pt-30">
                                        <p class="normaltextgray16"><i class="fal fa-check me-3 icon-gray" ></i>Näytetään hakutuloksissa</p>
                  
                                      </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 ">
                              <div class=" formed-price-green h-100">
                                  
                                  <div class="p-4">
                                    <div class="d-flex justify-content-between">
                                      <div class="">
                                        <p class="normaltextdeepgreen20">Boosted <span *ngIf="days_ad_amount > 0">(Valittu)</span></p>
                                      </div>
                                      <div class="">
                                        <div class="formed-recom-card">
                                          <p class="normaltextwhite14 mb-0">Suosittu</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="d-flex">
                                      <div class="">
                                        <h2 class="formed-green-price mb-0"><span *ngIf="pricing">{{pricing['feed']['ads']['price']}}</span>€</h2>
                                      </div>
                                      <div class="mt-3 ms-2">
                                        <p class="normaltextgreengradient16 mb-0">/pv</p>
                                      </div>
                                    </div>
                                    <div class="hr-green mt-4 mb-4"></div>
                                    <div class=" ">
                                      <p class=" normaltextdeepgreen16 mb-0"><img src="../../assets/icons/checkmark_simple.svg" class="me-2">Nostot etusivulle</p>
                                      <p class=" normaltextdeepgreen16 mb-0"><img src="../../assets/icons/checkmark_simple.svg" class="me-2">Nostot hakutuloksissa</p>
              
                                      <p class="normaltextdeepgreen16 mb-0"><img src="../../assets/icons/checkmark_simple.svg" class="me-2">Näkyvyyden tehostaminen</p>
                                    </div>
                                    <div class="" *ngIf="invoice_details_filled; else no_invoices_filled">
                                      <p class="normaltextgreen50016 mb-2 mt-4">Syötä päivien lukumäärä</p>
                                      <div class=" mb-2 col-12 col-md-12 p-0">
                                        <input type="number" onmousewheel="return false;" min="0" placeholder="" (keyup)="updatePrice()"  id="campaign" class="form-control form-control-green" >
                                        <label for="wage_hourly"></label>
                          
                                      </div>
                                      <div class=" mb-2 col-12 col-md-12 p-0">
                                        <p class="normaltextgreen50016 mb-2 mt-2">Lisää haluamasi viite (esim. kustannuspaikka)</p>
                                        <input type="text" min="0" placeholder=""  id="cost_center" class="form-control form-control-green" >
                                        <label for="wage_hourly"></label>
                          
                                      </div>                                       
                                    </div>
                                    <ng-template #no_invoices_filled>
                                      <div class="alert alert-warning mt-3 text-center">
                                        <p class="normaltextblue80016 text-center">Laskutustiedot ovat puutteelliset, siirry lisäämään tästä:</p>
                                        <button class="btn btn-formed-main-blue text-center" routerLink="/{{businessID}}/edit-business">Täydennä tiedot</button>
                                      </div>
                                      </ng-template>

                                  </div>
                              </div>
                          </div>
              
                        </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="bg-w">
                        <div class="p-4">
                          <div *ngIf="!openingID" class="margin-system">
                            <p class="formed-sub-title">Ilmoituksen hinta</p>
                            <div class="bg-blue margin-card">
                              <div class="ps-3 pe-3 pt-4 pb-4">
                                <div class="d-flex justify-content-between">
                                  <div class="">
                                    <p class="normaltextgray16">Mainos ({{days_ad_amount}}) päivää</p>
                                  </div>
                                  <div class="">
                                    <p class="normaltextgray16">{{price.toFixed(2)}}€</p>
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <div class="">
                                    <p class="normaltextgray16">Alv 25,5% </p>
                                  </div>
                                  <div class="">
                                    <p class="normaltextgray16">{{vat_amount.toFixed(2)}}€</p>
                                  </div>
                                </div>
                                <hr class="hr-gray">
                                <div class="d-flex justify-content-between">
                                  <div class="">
                                    <p class="semiboldtextblue16">Yhteensä sis.alv</p>
                                  </div>
                                  <div class="">
                                    <p class="semiboldtextblue16">{{total_sum.toFixed(2)}}€</p>
                                  </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div> -->
                </div>
                <div class="mt-2">
                  <button [disabled]="form.invalid" class="btn mt-4  btn-formed-main-blue ">{{btnText}}</button>

                </div>
        
        
                    </div>
                  </div>
        
        
        
          
                    
                          
                      <div class="form-inline mt-4 pb-4">
                        <div class="form-group mb-2 flex-row">
                        </div>
                      </div>
                    </form>
          
                  </div>
                </div>
        
          </div>
          </div>
        </div>
      </div>
  </div>


    <!-- Modal Check before deleting offer -->
    <button data-bs-toggle="modal" id="open-subtypes" data-bs-target="#open-subtypes-modal" style="display:none"></button>
    <div class="modal fade" id="open-subtypes-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Valitse listasta alakategoria</h5>
            <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
            <button type="button" class="close" id="close-sub-md-modal" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <h5 class="text-center">Valitse alakategoria</h5>
            <div class="col-12 row m-0 pt-4 pb-4">
                <div class="table-responsive" *ngIf="selectedSubtypes && selectedSubtypes.length > 0">
                    <table class="table align-items-center table-flush">
                        <thead class="thead-light">
                            <tr>
                                <th>Nimi</th>
                                <th>Valitse</th>
                            </tr>
                        </thead>
                        <tbody class="tbody-light">
                            <tr *ngFor="let data of selectedSubtypes">
                                <td>{{data.name_fi}}</td>
                                <td><button class="btn btn-formed-main-green" (click)="selectSubtype(data)"><i class="fas fa-plus-circle me-2"></i>Lisää</button></td>
                            </tr>
                        </tbody>
      
                    </table>
                </div>
            </div>
        </div>
        </div>
    </div>
    </div>


        <!-- Modal Check before deleting offer -->
        <button data-bs-toggle="modal" id="open-subtypes" data-bs-target="#open-feed-details" style="display:none"></button>
        <div class="modal fade" id="open-feed-details" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Kampanja</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                <button type="button" class="close" id="close-sub-md-modal" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <h5 class="text-center">Mikä on Kampanja?</h5>
                <p>Kampanjan avulla voit tehostaa ilmoituksesi näkyvyyttä.</p>
            </div>
            </div>
        </div>
        </div>

                <!-- Modal Check before deleting offer -->
                <button data-bs-toggle="modal" id="location-modal" data-bs-target="#data-location-modal" style="display:none"></button>
                <div class="modal fade" id="data-location-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Useita kohteita</h5>
                        <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                        <button type="button" class="close" id="close-location-modal" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Löysimme useita kohteita. Valise näistä kohteista oikea.</p>

                        <ul>
                          <li class="formed-list" *ngFor="let data of locationData">
                            <div class="col-12 row m-0">
                              <div class="col-2">
                                  <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="30" height="30" alt="">
                              </div>
                              <div class="col-7">
                                  <p class="mb-0">{{data['address']['town']}} ({{data['address']['postcode']}})</p>
                                  <p class="gray mb-0"><span>{{data['display_name']}} </span></p>
                              </div>
                              <div class="col-3">
                                <p (click)="selectLocation(data)" class="btn btn-formed-main-green">Valitse</p>
                              </div>
                          </div>
                          </li>
                        </ul>
                    </div>
                    </div>
                </div>
                </div>

              <!-- Modal Check before deleting offer -->
              <button data-bs-toggle="modal" id="users-modal" data-bs-target="#data-users-modal" style="display:none"></button>
              <div class="modal fade" id="data-users-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog " role="document">
                  <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">Valitse käyttäjät</h5>
                      <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                      <button id="close-open-profile" type="button" id="close-modal-open" class="btn-close" data-bs-dismiss="modal">
                        <i class="fal fa-times"></i>
                        </button>
                  </div>
                  <div class="modal-body p-4" *ngIf="users.length > 0">
                      <div class="" *ngFor="let data of users">
                        <div class="col-12 row">
                          <div class="col-1">
                            <input type="checkbox" [checked]="data.checked" (change)="saveFavourites(data)" id="user_{{data._id}}">
                          </div>
                          <div class="col-11">
                              <p class="normaltextblue80016">{{data.firstName}} {{data.lastName}}</p>
                          </div>
                        </div>
                      </div>

                  </div>
                  </div>
              </div>
              </div>
    

